import React from "react";

import GeneralAccessManagement from "./GeneralAccess";
import AttendanceViewManagement from "./View";

// Import utilities
import { isAllowedToDo } from "permissions-hub";
import { ACCEPTED_PERMISSIONS } from "constants";
import { isReadOnly } from "validations";

const AttendanceManagement = ({ permissions }) => {
  // Is read-only ?
  const isReadOnlyy = isReadOnly(permissions);

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check for allowance of manual marking
  const allowedManualPunch = isAllowedToDo(
    ACCEPTED_PERMISSIONS["create"],
    permissions
  );
  // Check for allowance of merging
  const allowedMerge = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions
  );

  // Pass AttendanceViewManagement as a prop if isGeneralAccess is true
  const ManagementComponent = isReadOnlyy ? (
    <AttendanceViewManagement />
  ) : (
    <GeneralAccessManagement
      isAllowedToRead={isAllowedToRead}
      allowedManualPunch={allowedManualPunch}
      allowedMerge={allowedMerge}
      AttendanceViewManagement={AttendanceViewManagement}
    />
  );

  return ManagementComponent;
};

export default AttendanceManagement;